import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "classLeader",
  "use": "classLeader-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" fill=\"none\" viewBox=\"0 0 16 16\" id=\"classLeader\"><g><g><rect x=\"4\" y=\"3\" width=\"9\" height=\"6\" rx=\"0\" fill=\"#0357E2\" fill-opacity=\"1\" /></g><g><path d=\"M3,10L3,2L13.46,2C13.7582,2,14,2.241766,14,2.54L14,9.46C14,9.758230000000001,13.7582,10,13.46,10L4,10L4,15L3,15L3,10ZM4,9L13,9L13,3L4,3L4,9Z\" fill-rule=\"evenodd\" fill=\"#0357E2\" fill-opacity=\"1\" /></g></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol